'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentAdvisory = require('./ContentAdvisory');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentAdvisory).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ContentAdvisory/index.js
// module id = 1165
// module chunks = 1